import Quill from 'quill';
const Parchment = Quill.import('parchment');
let Bold = Quill.import('formats/bold');


//Fix for jsp page so that we get bold text on jsp page
export const BoldEdit = () => {
    class BoldBlot extends Bold {
    }
    BoldBlot.blotName = 'bold';
    BoldBlot.tagName = ['STRONG'];
    BoldBlot.className = 'strong';
    return BoldBlot;
};

//Overwrite the existing settings for text-align which is was orginally a class setting
export const TextAlignContent = () => {
    return new Parchment.Attributor.Style('align', 'text-align', {
        whitelist: ['right', 'center', 'justify']
    });

};

//Overwrite the existing setting for indent styling
export const IndentStyle = () => {
    class IndentAttributor extends Parchment.Attributor.Style {
        add (node, value) {
            if (value === 0) {
                this.remove(node);
                return true;
            } else {
                return super.add(node, `${value}em`);
            }
        }
    }

    return new IndentAttributor('indent', 'text-indent', {
        scope: Parchment.Scope.BLOCK,
        whitelist: ['1em', '2em', '3em', '4em', '5em', '6em', '7em', '8em', '9em']
    });
};
